module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xthor1-db34e66fccec41c94df4a89743d61c96.jpg";